import React, { useEffect, useId, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { makeKey, formatChemicalFormulas, nbsp } from "../utilities";
import infoIcon from "../../images/icons/info.svg";
const SideBarRadioButtons = ({ multiRadioButtonsConfig, chosenCategory, chosenValue, pageType, }) => {
    const [sidebarTitles, setSidebarTitles] = useState({
        title: "",
        subtitle: "",
        tooltip: { title: true, sub: true },
    });
    // TODO to consider getting the title and subtitle also from the backend
    useEffect(() => {
        switch (pageType) {
            case "environmental_indicators_data":
                setSidebarTitles({
                    title: "Emisja\nzanieczyszczeń",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "economic_zite_data":
                setSidebarTitles({
                    title: "Dane ZITE",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "economic_pite_data":
                setSidebarTitles({
                    title: "Dane PITE",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "social_data":
                setSidebarTitles({
                    title: "Ubóstwo energetyczne",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            default:
                break;
        }
    }, [pageType]);
    const TooltipSocial = (React.createElement(Tooltip, null, nbsp(`Ubóstwo energetyczne - występuje wtedy, gdy gospodarstwo domowe nie jest w
      stanie zapewnić sobie wystarczającego poziomu ciepła, chłodu, oświetlania
      i energii do zasilania urządzeń w wyniku połączenia niskich dochodów,
      wysokich wydatków energetycznych i niskiej efektywności energetycznej
      budynku (GUS).`)));
    const TooltipEnvironmental = (React.createElement(Tooltip, null, formatChemicalFormulas(nbsp(`Emisja zanieczyszczeń jest to wprowadzenie do środowiska (w tym przypadku do atmosfery) zanieczyszczeń. Uwolnione zanieczyszczenia są transportowane w atmosferze co przekłada się na zmianę ich stężenia oraz koszty środowiskowe. W portalu określono wskaźniki oraz afekty środowiskowe zanieczyszczeń pyłowych (PM10, PM2.5), gazów cieplarnianych (CH4, CO2) oraz innych zanieczyszczeń bezpośrednio wpływających na zdrowie ludzkie (SO2, NOx).`))));
    const TooltipPITE = (React.createElement(Tooltip, null, nbsp(`Polski Indeks Transformacji Energetycznej (PITE) stanowi wariant
      Zmodyfikowanego Indeksu Transformacji Energetycznej (ZITE), który również
      opiera się na zaawansowanej metodologii statystycznej rekomendowanej przez
      OECD oraz Wspólne Centrum Badawcze (JRC) Komisji Europejskiej pozwalającej
      ograniczyć wpływ subiektywnych decyzji na konstrukcję wskaźnika
      kompozytowego, ale w odróżnieniu od ZITE jego wartość jest wyznaczana
      wyłącznie na podstawie analizy szeregów czasowych dotyczących polskiej
      gospodarki. W ten sposób wartości PITE w pełni korespondują do realiów
      polskiej energetyki i nie są zniekształcane przez zjawiska i procesy
      występujące w innych regionach świata.`)));
    const TooltipZITE = (React.createElement(Tooltip, null, nbsp(`Zmodyfikowany Indeks Transformacji Energetycznej (ZITE) stanowi ulepszoną
      wersję indeksu ETI publikowanego przez Światowe Forum Ekonomiczne. ZITE
      opiera się na zaawansowanej metodologii statystycznej rekomendowanej przez
      OECD oraz Wspólne Centrum Badawcze (JRC) Komisji Europejskiej, co pozwala
      ograniczyć wpływ subiektywnych decyzji na konstrukcję wskaźnika
      kompozytowego.`)));
    const getTooltipForTitle = () => {
        switch (pageType) {
            case "social_data":
                return TooltipSocial;
            case "environmental_indicators_data":
                return TooltipEnvironmental;
            case "economic_pite_data":
                return TooltipPITE;
            case "economic_zite_data":
                return TooltipZITE;
            default:
                return TooltipSocial;
        }
    };
    return (React.createElement("section", { className: "radioSidebar" },
        React.createElement("div", { className: "card mb-4" },
            React.createElement("div", { className: "card-body" },
                React.createElement("h1", { className: "fs-4 fw-bold mb-0 d-flex justify-content-between align-items-center", style: { whiteSpace: "pre-line" } },
                    sidebarTitles.title,
                    sidebarTitles.tooltip.title && (React.createElement(OverlayTrigger, { placement: "right", overlay: getTooltipForTitle() },
                        React.createElement("img", { src: infoIcon, alt: "Ikona informacji", className: "ms-1" })))))),
        sidebarTitles.subtitle !== undefined && (React.createElement("div", { className: "card mb-4" },
            React.createElement("div", { className: "card-body" },
                React.createElement("h6", { className: "mb-0" },
                    sidebarTitles.subtitle,
                    " ",
                    sidebarTitles.tooltip.sub && (React.createElement(OverlayTrigger, { placement: "right", overlay: TooltipSocial },
                        React.createElement("img", { src: infoIcon, alt: "Ikona informacji", className: "ms-1" }))))))),
        multiRadioButtonsConfig.map((group) => {
            return (React.createElement("div", { key: group.categoryId, className: "card mb-4" },
                React.createElement("div", { className: "card-header" },
                    React.createElement("h5", { className: "mb-0" }, group.category)),
                React.createElement("div", { className: "card-body" }, group.values.map((value) => {
                    const uniqueID = useId();
                    const handleClick = () => {
                        if (!value.disabled && value.callback !== undefined) {
                            value.callback(group.category, group.categoryId, value.value, value.id);
                        }
                    };
                    return (React.createElement("div", { key: makeKey(), className: "form-check mb-2 clickable", onClick: handleClick },
                        React.createElement("input", { disabled: value.disabled, type: "radio", id: value.id + uniqueID, name: "left-menu", value: value.id, onChange: handleClick, checked: chosenCategory.chosenCategoryId === group.categoryId &&
                                chosenValue.chosenValueId === value.id, className: "form-check-input clickable" }),
                        React.createElement("label", { htmlFor: value.id + uniqueID, className: "form-check-label clickable" }, formatChemicalFormulas(value.value))));
                }))));
        })));
};
export default SideBarRadioButtons;
